import { useContext, useEffect, useState, useRef, useCallback } from 'react';
import './FileUpload.less';
import { UploadContext } from '@/context/vidtranslate/UploadContext';
import Icon from '@/components/iconfont/Icon';
import { getToken } from '@/utils/cookie';
import { useDashboardData } from '@/hooks/DashboardHooks';
import Uploader from '@/utils/vidtranslateUpload';
import { vidTranslation } from '@/api';
import { useDrawer } from '@/hooks/DrawerHooks.js';
import { useTranslation } from 'react-i18next';
import ChooseLanguage from '@/components/chooseLanguage/ChooseLanguage.jsx';
// import { CheckEquity } from '@/utils/CheckEquity';
import message from '@/utils/message.jsx';
import { Switch } from '@radix-ui/themes';
import { captureVideoFrame } from '@/utils/media.js';
export default function FileUpload({ onUpload, onCreateSuccess }) {
  const { setIsOpen } = useDrawer();
  const [showSourceLanguage, setShowSourceLanguage] = useState(false);
  const [showTargetLanguage, setShowTargetLanguage] = useState(false);
  const [showPeopleCount, setShowPeopleCount] = useState(false);
  const { userData, pointConsume, languageList: defaultLanguage } = useDashboardData();
  const fileUploadStartTime = useRef(0);
  const isFirstRender = useRef(true);
  // const [fileData, setFileData] = useState(null);
  const {
    uploadStatus,
    setUploadStatus,
    uploadFile,
    setUploadFile,
    playUrl,
    setPlayUrl,
    peopleCount,
    setPeopleCount,
    sourceLanguage,
    languageList,
    targetLanguageList,
    propleList,
    targetLanguage,
    setSourceLanguage,
    setTargetLanguage,
    // setSyncFlag,
    syncFlag,
    // generateSpeech,
    // setGenerateSpeech,
    progressNum,
    setProgressNum,
    setUploadData,
    setCoverUploaderImg,
    coverUploaderImg,
    uploadData,
    videoDuration,
    setVideoDuration,
    videoMinutes,
    setVideoMinutes,
    setVidUploadInstance,
    setVidtranslateModalShow,
    uploadMessage,
    setUploadMessage,
    // setSyncModalShow,
    // submitLoading,
    // setSubmitLoading,
    showAddSubtitles,
    ttsState,
    setTtsState,
    translateState,
    setTranslateState,
    fileVideoTime,
    targetLanguageList_subtitle,
    languageList_subtitle,
    setDefaultLanguage,
    popUpClose,
  } = useContext(UploadContext);
  const fileUploadIpt = useRef(null);
  const [chooselanguageList, setChooselanguageList] = useState(languageList_subtitle);
  const coverImage = useRef('');
  const { t } = useTranslation();
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 点击字体选择框以外的区域时关闭下拉列表
      const selectSourct = document.querySelector('.select_sourct');
      if (selectSourct && !selectSourct.contains(event.target)) {
        setShowSourceLanguage(false);
      }
      const selectTarget = document.querySelector('.select_target');
      if (selectTarget && !selectTarget.contains(event.target)) {
        setShowTargetLanguage(false);
      }
      const selectPeople = document.querySelector('.select_people');
      if (selectPeople && !selectPeople.contains(event.target)) {
        setShowPeopleCount(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  // useEffect(() => {
  //   if (!vidtranslateModalShow && uploadStatus !== 2) {
  //     fileUploadIpt.current.value = '';
  //   }
  // }, [vidtranslateModalShow, uploadStatus]);
  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    // setFileData(file);
    setUploadFile(file);
    if (!getToken()) {
      e.target.value = '';
      return;
    }
    if (!e.target.value) {
      setUploadStatus(0);
      setPlayUrl('');
      setUploadFile(null);
      return;
    }
    if (!e.target.files[0].type.includes('video')) {
      e.target.value = '';
      setUploadStatus(0);
      setPlayUrl('');
      setUploadFile(null);
      setUploadMessage(t('As_CreateProjectTrans_ErrorUploadFormat'));
      return;
    }
    const allowedTypes = ['video/mp4', 'video/quicktime'];
    if (!allowedTypes.includes(e.target.files[0]?.type)) {
      setUploadStatus(0);
      setPlayUrl('');
      setUploadFile(null);
      e.target.value = '';
      setUploadMessage(t('As_CreateProjectTrans_ErrorUploadFormat'));
      return;
    }
    const maxSizeInBytes = 500 * 1024 * 1024; // 500MB
    console.log(e.target.files, 'e.target.files[0].size');

    if (e.target.files[0].size > maxSizeInBytes) {
      setUploadStatus(0);
      setPlayUrl('');
      setUploadFile(null);
      e.target.value = '';
      setUploadMessage(t('As_CreateProjectTrans_ErrorUploadSize'));
      return;
    }
    // 检查视频时长是否超过10分钟
    const video = document.createElement('video');
    video.src = URL.createObjectURL(e.target.files[0]);
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);
      // if (video.duration > 600 && !CheckEquity({ userData, type: 'freeCount' })) {
      //   e.target.value = '';
      //   setUploadStatus(0);
      //   setPlayUrl('');
      //   setUploadFile(null);
      //   setUploadMessage('Video duration has a 10 min limit');
      //   return;
      // }
      // if (video.duration > 1800 && CheckEquity({ userData, type: 'freeCount' })) {
      //   e.target.value = '';
      //   setUploadStatus(0);
      //   setPlayUrl('');
      //   setUploadFile(null);
      //   setUploadMessage('Video duration has a 30 min limit');
      //   return;
      // }
      // 格式化视频时长
      const minutes = Math.floor(video.duration / 60);
      const seconds = Math.floor(video.duration % 60);
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setVideoDuration(formattedDuration);
      // 向上取整计算视频时长
      const totalMinutes = Math.ceil(video.duration / 60);
      setVideoMinutes(totalMinutes);
      fileVideoTime.current = Math.round(video.duration);
      sendBuryPoint(totalMinutes);

      if (showAddSubtitles) {
        window.onClickGATrackEvent('addsub-file-cover');
      } else {
        window.onClickGATrackEvent('translate-file-cover');
      }
      fileUploadStartTime.current = new Date().getTime();
      handleClickUpload(e.target.files[0], 1);
    };
    window.onClickGATrackEvent(
      showAddSubtitles ? 'addsub-file-upload-click' : 'translate-file-upload-click',
    );
  };
  useEffect(() => {
    if (uploadFile) {
      const fileUrl = URL.createObjectURL(uploadFile);
      setPlayUrl(fileUrl);
    }
  }, [uploadFile]);
  const handleSourceLanguage = (val) => {
    setSourceLanguage(val);
  };
  const handleTargetLanguage = (val) => {
    setTargetLanguage(val);
  };
  const handleChangePeople = (val) => {
    setPeopleCount(val);
  };
  // const handleCheckboxChangeSync = (e) => {
  //   window.onClickGATrackEvent('translate-click-lipsync');
  //   if (e.target.checked) {
  //     setSyncModalShow(true);
  //   }
  //   setSyncFlag(e.target.checked);
  // };
  // const handleCheckboxChangeGenerate = (e) => {
  //   setGenerateSpeech(e.target.checked);
  // };
  const handleCheckboxChangeTTS = (e) => {
    if (!showAddSubtitles && e) {
      window.onClickGATrackEvent('translate-toggle-tts');
    }
    setTtsState(e);
    // sendBuryPoint();
  };
  const handleCheckboxChangeTranslate = (e) => {
    if (showAddSubtitles && e) {
      window.onClickGATrackEvent('addsub-toggle-double');
    }
    setTranslateState(e);
    // sendBuryPoint();
  };
  useEffect(() => {
    if (showAddSubtitles) {
      const data = translateState ? targetLanguageList_subtitle : languageList_subtitle;
      setChooselanguageList(data);
      const isHave = data.find((res) => res.name === sourceLanguage.name);
      if (!isHave) {
        setDefaultLanguage(defaultLanguage);
      }
    }
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (videoMinutes <= 0) return;
    sendBuryPoint();
  }, [ttsState, translateState]);

  const sendBuryPoint = (time) => {
    const stats = canTranslate(time || 0);
    if (!stats) {
      window.onClickGATrackEvent(
        showAddSubtitles ? 'addsub-need-upgrade' : 'translate-need-upgrade',
        { video_duration: time || videoMinutes, video_type: 'file' },
      );
    }
  };
  const canTranslate = (val) => {
    let type = '';
    if (!showAddSubtitles) {
      type = ttsState ? 'translation_and_tts' : 'translation';
    } else {
      type = translateState ? 'add_subtitle_and_translation' : 'add_subtitle';
    }
    const consume = pointConsume?.filter((res) => res.mode === type);
    const needCredits = (val || videoMinutes) * consume[0]?.number;
    const user_credits = userData?.actualTotalPoints || 0;
    return user_credits >= needCredits;
    // return videoMinutes <= userData?.userSubscription?.translationQuotaRemaining;
  };

  const duration = useRef(0);
  const uploadSnapshot = useCallback(async (file) => {
    const url = URL.createObjectURL(file);
    let video = document.createElement('video');
    video.muted = true;
    video.autoplay = true;
    await new Promise((resolve) => {
      video.addEventListener('canplay', resolve, {
        once: true,
      });
      video.src = url;
      video.play();
    });
    fileUploadStartTime.current = new Date().getTime();
    duration.current = Math.floor(video.duration * 1000);
    await new Promise((resolve) => setTimeout(resolve, 200));
    const imageBlob = await captureVideoFrame(video);
    video.src = '';
    video.load();
    video = null;
    URL.revokeObjectURL(url);
    return imageBlob;
  }, []);
  const handleClickUpload = async (files, status) => {
    // setUploadFile(files);
    setUploadStatus(status);
    setUploadMessage('');

    console.log(status, 'statusstatus');

    if (status !== 1 || status === 2) {
      return;
    }
    window.gtag('event', 'file_input_click');
    const uploader = new Uploader();

    // 创建Promise包装上传过程
    const uploadVideoPromise = new Promise((resolve, reject) => {
      popUpClose.current = true;
      uploader.on('progress', (pro) => {
        setProgressNum(pro * 100);
      });
      uploader.on('success', (res) => {
        const time = Math.round((new Date().getTime() - fileUploadStartTime.current) / 1000);
        window.onClickGATrackEvent(
          showAddSubtitles ? 'addsub-file-uploaded' : 'transalte-file-uploaded',
          { upload_duration: time },
        );
        setUploadData(res);
        setTimeout(() => {
          resolve();
        }, 50);
      });
      uploader.on('failed', () => {
        uploader.retry();
      });
      uploader.on('error', () => {
        setUploadStatus(0);
        setProgressNum(0);
        reject();
      });
      uploader.on('getShardlink', () => {
        popUpClose.current = false;
      });
    });

    setVidUploadInstance(uploader);
    uploader.uploadFileWithSlice(files);

    // // 获取视频第一帧作为封面图
    // const video = document.createElement('video');
    // video.src = URL.createObjectURL(files);
    // video.preload = 'metadata';

    // // 创建Promise包装封面图上传过程
    // const uploadCoverPromise = new Promise((resolve) => {
    //   video.addEventListener('loadedmetadata', () => {
    //     video.currentTime = 0;
    //   });

    //   video.addEventListener('seeked', async () => {
    //     await new Promise((resolve) => setTimeout(resolve, 200));
    //     const canvas = document.createElement('canvas');
    //     const ctx = canvas.getContext('2d');

    //     canvas.width = video.videoWidth;
    //     canvas.height = video.videoHeight;
    //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    //     canvas.toBlob((blob) => {
    //       // const blobUrl = URL.createObjectURL(blob);
    //       // console.log('封面图预览地址:', blobUrl);
    //       if (blob) {
    //         coverImage.current = URL.createObjectURL(blob);
    //       }
    //       const coverFile = new File([blob], 'cover.png', { type: 'image/png' });

    //       const coverUploader = new Uploader();
    //       coverUploader.on('success', (res) => {
    //         console.log('触发2');
    //         setCoverUploaderImg(res);
    //         setTimeout(() => {
    //           resolve();
    //         }, 50);
    //       });
    //       coverUploader.on('failed', () => {
    //         coverUploader.retry();
    //       });
    //       coverUploader.uploadFileWithSlice(coverFile);
    //     }, 'image/png');
    //   });
    // });
    const imageBlob = await uploadSnapshot(files);
    coverImage.current = URL.createObjectURL(imageBlob);
    const coverFile = new File([imageBlob], 'cover.png', { type: 'image/png' });
    const uploadCoverPromise = new Promise((resolve) => {
      const coverUploader = new Uploader();
      coverUploader.on('success', (res) => {
        console.log('触发2');
        setCoverUploaderImg(res);
        setTimeout(() => {
          resolve();
        }, 50);
      });
      coverUploader.on('failed', () => {
        coverUploader.retry();
      });
      coverUploader.uploadFileWithSlice(coverFile);
    });
    // 等待两个上传都完成
    await Promise.all([uploadVideoPromise, uploadCoverPromise]);
    console.log('触发3');
    setUploadStatus(2);
  };
  const handleSubmit = async () => {
    // if (submitLoading) {
    //   return;
    // }
    // setSubmitLoading(true);
    const obj = {
      name: uploadFile.name.split('.').slice(0, -1).join('.'),
      type: 1, // 增加type =3  上传youtube链接
      usage: showAddSubtitles ? 2 : 1, // 0 重写  1 翻译
      thumbnailUpload: coverUploaderImg,
      streams: [
        {
          type: 1,
          upload: uploadData,
          zIndex: 0,
          isMirrorOpen: false,
        },
      ],
      language: sourceLanguage.name, // 原始语言（翻译项目需要传入）
      translationLanguage: targetLanguage.name, // 目标语言（翻译项目需要传入）
      peopleNumber: peopleCount.id,
      lipSync: syncFlag, // 嘴型同步开关
      generateSpeech: showAddSubtitles ? false : ttsState, // 是否TTS
      useTranslate: showAddSubtitles ? translateState : true, // 是否翻译
      mode: showAddSubtitles ? 'add_subtitle' : 'translation',
      imgUrl: coverImage.current, //临时数据，用来在项目列表展示封面图
      tempId: uploadData?.uploadId + Date.now(),
    };
    if (!obj.useTranslate) {
      delete obj.translationLanguage;
    }
    const obj1 = {
      uploadType: 0,
      usage: showAddSubtitles ? 2 : 1, // 0 重写  1 翻译
      video: uploadData,
      viewImage: coverUploaderImg,
      sourceLanguage: sourceLanguage.name,
      targetLanguage: targetLanguage.name,
      peopleNumber: peopleCount.id,
      openLibSync: syncFlag,
    };

    try {
      let res;
      onUpload(obj);
      setProgressNum(0);
      setUploadStatus(0);
      setVidtranslateModalShow(false);
      if (!syncFlag) {
        res = await vidTranslation.translation(obj);
      } else {
        res = await vidTranslation.heygenTranslation(obj1);
      }
      if (res.code === 0) {
        // setNeedRefreshProjects(Date.now());
        onCreateSuccess(res.data);
      } else {
        message.error(t('As_Error_Network'), {
          id: 'only',
        });
      }
    } catch (error) {
      console.log(error);
    }
    // setSubmitLoading(false);
  };
  return (
    <div className="file_upload_box">
      <div className="upload_box">
        {uploadStatus === 0 && (
          <div className="select_upload">
            <input
              type="file"
              ref={fileUploadIpt}
              accept=".mov,.mp4"
              className="uploadipt"
              onDrop={() => {
                if (showAddSubtitles) {
                  window.onClickGATrackEvent('addsub-select-file');
                } else {
                  window.onClickGATrackEvent('translate-select-file');
                }
              }}
              onDragOver={(e) => {
                e.preventDefault();
              }}
              onClick={() => {
                if (showAddSubtitles) {
                  window.onClickGATrackEvent('addsub-select-file');
                } else {
                  window.onClickGATrackEvent('translate-select-file');
                }
              }}
              onChange={handleChangeFile}
            />
            <Icon name="icon-upload" className="upload_icon" />
            <div className="text1">
              {/* Drop your file here, or <span>click to browse</span> */}
              <span>{t('As_Edit_UploadClick334')}</span>
              <span> {t('As_Edit_UploadDrop334')}</span>
            </div>
            <div className="text2">
              {/* MP4 or MOV format. Less than 2GB. */}
              {t('As_Edit_UploadFormat334')}
              <span> {t('As_Edit_UploadSize334')}</span>
            </div>
          </div>
        )}
        {uploadStatus >= 1 && (
          <div className="select_upload">
            <div className="upload_file_box">
              {playUrl && <video src={playUrl} />}
              <div className="progress_filename">
                <div className="filename">{uploadFile?.name}</div>
                {uploadStatus < 2 && (
                  <progress
                    className="progress progress-primary w-[250px]"
                    value={progressNum}
                    max="100"></progress>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="form_info">
        <div className="info_box video_language">
          <div className="text">
            {/* Video Language */}
            {t('As_CreateProjectTrans_VideoLang')}
          </div>
          <div className={`select_box select_sourct ${showSourceLanguage && 'select_action'}`}>
            <div
              className={`select_click_mask ${showSourceLanguage && 'select_click_mask_active'}`}
              onClick={() => {
                setShowSourceLanguage(!showSourceLanguage);
              }}></div>
            <div className="select_value">
              <div className="text">{sourceLanguage?.language || t('As_Home_SelectLang')}</div>
              <Icon name={showSourceLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
            </div>
            {showSourceLanguage && (
              <div className="select_list choose_language">
                <ChooseLanguage
                  languageList={showAddSubtitles ? chooselanguageList : languageList}
                  language_action={sourceLanguage}
                  onChang={(item) => {
                    handleSourceLanguage(item);
                    setShowSourceLanguage(!showSourceLanguage);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {!showAddSubtitles && (
          <div className={`info_box target_language`}>
            <div className="text">
              {showAddSubtitles
                ? t('As_CreateProjectSub_SubLang')
                : t('As_CreateProjectTrans_TargetLang')}
            </div>
            <div className={`select_box select_target ${showTargetLanguage && 'select_action'}`}>
              <div
                className={`select_click_mask ${showTargetLanguage && 'select_click_mask_active'}`}
                onClick={() => {
                  setShowTargetLanguage(!showTargetLanguage);
                }}></div>
              <div className="select_value">
                <div className="text">{targetLanguage?.language}</div>
                <Icon name={showTargetLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
              </div>
              {showTargetLanguage && (
                <div className="select_list choose_language">
                  <ChooseLanguage
                    languageList={targetLanguageList}
                    language_action={targetLanguage}
                    language_disabled={sourceLanguage}
                    onChang={(item) => {
                      handleTargetLanguage(item);
                      setShowTargetLanguage(!showTargetLanguage);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <div className={`info_box speaker_num ${showAddSubtitles && 'hidden'}`}>
          <div className="text">
            {/* Speaker num */}
            {t('As_CreateProjectTrans_SpeakerNum')}
          </div>
          <div
            className={`select_box select_people  ${showPeopleCount && 'select_click_mask_active'} ${showPeopleCount && 'select_action'}`}
            onClick={() => {
              setShowPeopleCount(!showPeopleCount);
            }}>
            <div className={`select_value`}>
              <div className="text">{t(peopleCount?.name)}</div>
              <Icon name={showPeopleCount ? 'icon-arrow-left' : 'icon-arrow-down'} />
            </div>
            <div className="select_list" style={{ display: showPeopleCount ? 'block' : 'none' }}>
              {propleList.map((item, index) => (
                <div
                  key={index}
                  className={`select_item ${item.id === peopleCount?.id && 'active_people_item'}`}
                  onClick={() => {
                    handleChangePeople(item);
                  }}>
                  {t(item.name)}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div className={`info_box lips_sync ${showAddSubtitles && 'hidden'}`}>
          <div className="text">Generate speech</div>
          <input
            type="checkbox"
            className="toggle"
            checked={generateSpeech}
            onChange={handleCheckboxChangeGenerate}
          />
        </div> */}
        {/* {generateSpeech && ( */}
        {/* <div className={`info_box lips_sync ${showAddSubtitles && 'hidden'}`}>
          <div className="text">
            {t('As_CreateProjectTrans_Lip')}
          </div>
          <input
            type="checkbox"
            className="toggle"
            checked={syncFlag}
            onChange={handleCheckboxChangeSync}
          />
        </div> */}
        {/* )} */}
        {showAddSubtitles ? (
          <div className={`info_box`}>
            <div className="text">{t('As_Edit_Subtitlechoice')}</div>
            <Switch
              className="toggle toggle_checkbox"
              checked={translateState}
              onCheckedChange={handleCheckboxChangeTranslate}
            />
          </div>
        ) : (
          <div className={`info_box`}>
            <div className="text">{t('As_Edit_TTS')}</div>
            <Switch
              className="toggle toggle_checkbox"
              checked={ttsState}
              onCheckedChange={handleCheckboxChangeTTS}
            />
          </div>
        )}
        <div
          className={`info_box target_language ${!(showAddSubtitles && translateState) && 'hidden'}`}>
          <div className="text">{t('As_CreateProjectSub_SubLang')}</div>
          <div className={`select_box select_target ${showTargetLanguage && 'select_action'}`}>
            <div
              className={`select_click_mask ${showTargetLanguage && 'select_click_mask_active'}`}
              onClick={() => {
                setShowTargetLanguage(!showTargetLanguage);
              }}></div>
            <div className="select_value">
              <div className="text">{targetLanguage?.language || t('As_Home_SelectLang')}</div>
              <Icon name={showTargetLanguage ? 'icon-arrow-left' : 'icon-arrow-down'} />
            </div>
            {showTargetLanguage && (
              <div className="select_list choose_language">
                <ChooseLanguage
                  languageList={chooselanguageList}
                  language_action={targetLanguage}
                  language_disabled={sourceLanguage}
                  onChang={(item) => {
                    handleTargetLanguage(item);
                    setShowTargetLanguage(!showTargetLanguage);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="btnbox">
          <div className="duration_info">
            {uploadStatus >= 1 && userData?.userSubscription?.level > 1 && (
              <>
                <div className="duration">
                  <div className="text">
                    {/* Video duration */}
                    {t('As_CreateProjectTrans_VideoDuration')}
                  </div>
                  <div className="num">{videoDuration}</div>
                </div>
                <div className="duration">
                  <div className="text">
                    {/* Translation will consume */}
                    {t('As_CreateProjectTrans_CreditsCost')}
                  </div>
                  <div className="num">{videoMinutes} min</div>
                </div>
                <div className={`duration ${!canTranslate() && 'num_error'}`}>
                  <div className="text">
                    {/* My quota left */}
                    {t('As_CreateProjectTrans_CreditsLeft')}
                  </div>
                  <div className="num">
                    {userData?.userSubscription?.translationQuotaRemaining} min
                  </div>
                </div>
              </>
            )}
          </div>
          {canTranslate() && (
            <button
              className="btn btn-primary btn_submit"
              disabled={uploadStatus < 2 || !sourceLanguage?.name}
              onClick={() => {
                if (showAddSubtitles) {
                  window.onClickGATrackEvent('addsub-submit', {
                    source_lan: sourceLanguage.name,
                    sub_lan: targetLanguage.name,
                    video_type: 'file',
                    dual_sub: translateState,
                  });
                } else {
                  window.onClickGATrackEvent('translate-submit', {
                    source_lan: sourceLanguage.name,
                    target_lan: targetLanguage.name,
                    speaker_num: peopleCount.id,
                    // lip_sync: syncFlag,
                    voice_translation: ttsState,
                    video_type: 'file',
                  });
                }
                handleSubmit();
              }}>
              {/*{submitLoading && <span className="loading loading-spinner loading-sm"></span>}*/}
              {t('As_CreateProjectTrans_Button')}
            </button>
          )}
          {!canTranslate() && (
            <>
              <button
                className="btn btn-warning btn_upgrade"
                onClick={() => {
                  window.onClickGATrackEvent(
                    showAddSubtitles ? 'addsub-click-upgrade' : 'translate-click-upgrade',
                  );
                  setIsOpen(true);
                }}>
                {/* Upgrade */}
                {t('As_Recording_Upgrade')}
              </button>
            </>
          )}
        </div>
        {uploadMessage && <div className="error_message">{uploadMessage}</div>}
      </div>
    </div>
  );
}
